import { useEffect, useState } from 'react';
import { CustomInputProps, CustomInputState } from '../../Models/CustomInput';
import InputLabel from '../InputLabel/InputLabel';
import Select, { components } from 'react-select';
import { INPUT_TYPE } from '../../constants/Constant';
import DKInputDateTime from '../../components/common/DKInputDateTime';
import ic_info_warning from "../../assets/icons/ic_info_gray.svg";
import {
    DKIcon
  } from "deskera-ui-library";
import ReactTooltip from 'react-tooltip';
const CustomInput: React.FC<CustomInputProps> = (props) => {
    const initialState: CustomInputState = {
        hasError: props.hasError ? props.hasError : false,
        errorMsg: props.errorMsg ? props.errorMsg : 'Cannot be left empty',
        placeholder: props.placeholder ? props.placeholder : '',
        labelName: props.labelName ? (props.labelName + (props.isRequired ? '*':'')) : '',
        isRequired: props.isRequired ? props.isRequired : false,
        isDisabled: props.isDisabled ? props.isDisabled : false,
        value: props.defaultValue ,
        labelClassName: props.labelClassName ? props.labelClassName : '',
        options: props['options']
    };
    const [inputState, setInputState] = useState<CustomInputState>(initialState);
    const inputChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (props.onChange) {
            const updatedState = inputState;
            updatedState.value =  e.target ? e.target.value : e['value'];
            setInputState({ ...updatedState });
            props.onChange(e);
        }
    };

    const customStyles = {

        valueContainer:base => ({
            ...base,
            padding:'2px 12px',
            backgroundColor: "#f4f4f6"
        }),
        option: (provided, state) => ({
          ...provided,
          textAlign:'left',
        }),
        control: (base, state) => ({
            ...base,
            background: "#f4f4f6",
            // css use later, save for referance

            // match with the menu
            // borderRadius:  "3px 3px 0 0" ,
            // Overwrittes the different states of border
            // borderColor: "green",
            // Removes weird border around container
            // boxShadow:  null,
            // "&:hover": {
              // Overwrittes the different states of border
            //   borderColor:  "blue"
            // }
          }),
          menu: base => ({
            ...base,
            // override border radius to match the box
            borderRadius: 0,
            // kill the gap
            marginTop: 0
          }),
          menuList: base => ({
            ...base,
            // kill the white space on first and last option
            padding: 0
          })
      }
      const IndicatorsContainer = props => {
        return (
          <div style={{ backgroundColor: '#f4f4f6' }}>
            <components.IndicatorsContainer {...props} />
          </div>
        );
      };

    useEffect(() => {
        const updatedState = inputState;
        updatedState.value = props.defaultValue
            ? props.defaultValue
            : initialState.value;
        setInputState({ ...updatedState });
        return () => {
            //   cleanup
        };
    }, [props.defaultValue]);
    const getDefualtSelectedValue = () =>{
        if(props.type == INPUT_TYPE.SELECT) {
            return props['options']? props['options'][inputState.value] : []
        } else if(props.type == INPUT_TYPE.MULTI_SELECT){
            let op:any = props.defaultValue
            return op.map(ele=>{
                return props['options'][ele]
            })
        }

    }
    return (
        <>

            <InputLabel
                text={inputState.labelName}
                className={`${inputState.labelClassName} fs-r`}
            />

            {(props.type!=INPUT_TYPE.SELECT&&props.type!=INPUT_TYPE.MULTI_SELECT)  && (<div className="d-flex align-items-center parent-width">
                <input
            type={props.type}
                className={
                    'border input-width input-w rounded border-gray-300 bg-gray1 text-sm font-normal tracking-normal placeholder-gray-600::placeholder px-3.5 ' +
                    (props.hasError
                        ? ' border-red '
                        : ' bg-gray1 ')
                }
                style={{ minHeight: '34px', borderStyle: 'solid' }}
                placeholder={inputState.placeholder}
                onChange={inputChanged}
                value={inputState.value}
                disabled={inputState.isDisabled}
            />
            {(props.info && props.info != "") &&<><ReactTooltip type="dark" place="right" html={true} effect='solid' />
                <span style={{ marginLeft:-32 }} data-tip={`<div class="text-align-left ">${props.info}</div>`} className="d-flex align-items-center">
                <DKIcon  src={ic_info_warning} className="ic-s mr-r"   />
                </span>
            </>}
            </div>)}
            {(props.type ==INPUT_TYPE.SELECT||props.type ==INPUT_TYPE.MULTI_SELECT)  && <Select components={{IndicatorsContainer}} isDisabled={inputState.isDisabled} isMulti={(props.type == INPUT_TYPE.MULTI_SELECT)? true: false} styles={customStyles} className={
                    'border rounded border-gray-300 align-items-left text-sm font-normal tracking-normal placeholder-gray-600::placeholder  ' +
                    (props.hasError
                        ? ' focus:outline-none focus:ring-2 focus:ring-red-500 border-red-400 '
                        : ' focus:outline-none focus:ring-2 focus:ring-blue-500 ')
                }
                style={{ minHeight: '37px', width: "-webkit-fill-available" }}  options={props['options']? props['options'] : []} defaultValue={getDefualtSelectedValue()} onChange={inputChanged} />}
            <p
                className={
                    'text-xs mx-1 mt-1 align-items-left d-flex p-h-l ' +
                    (props.hasError ? 'text-red' : 'text-transparent')
                }
            >
                {(props.errorMsg ? props.errorMsg: inputState.errorMsg)}
            </p>
        </>
    );
};

export default CustomInput;
